
import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Container } from 'react-bootstrap';
import headerImg from '../assets/images/pushtheboat_logo.svg';

export default class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }

    render() {
        return (
            <div>
                <Container>
                    <div className="header">
                        <Row>
                            <img src={headerImg} alt=""/>
                            <Col xs={0} m={4}></Col>
                            <Col xs={2}> <NavLink activeStyle={this.style} to="/">Walks</NavLink></Col>
                            <Col xs={2}><NavLink activeStyle={this.style} to="/Library">Library</NavLink></Col>
                            <Col xs={2}> <NavLink activeStyle={this.style} to="/about">About</NavLink></Col>
                        </Row>
                    </div>
                </Container>
            </div>
        );
    }
}
